<form #mapForm="ngForm">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="data.group.name" name="name" required>
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ac-input-container label="Routing policy between groups" class="fullWidth">
    <ac-select
      [(acModel)]="data.group.policyBetweenGroups"
      [items]="data.routingPolicyOptionsBetweenGroups"
      [searchable]="true"
      [multiple]="false"
      [allowClear]="false"
      [bindValue]="'server'"
      [bindLabel]="'label'">
    </ac-select>
  </ac-input-container>

  <ac-input-container label="Routing policy inside group" class="fullWidth">
    <ac-select
      [(acModel)]="data.group.policyInsideGroup"
      [items]="data.routingPolicyOptionsInsideGroup"
      [searchable]="true"
      [multiple]="false"
      [allowClear]="false"
      [bindValue]="'server'"
      [bindLabel]="'label'">
    </ac-select>
  </ac-input-container>

  <ac-line-separator [title]="'Groups'"></ac-line-separator>

  <div class="routing-servers-container">
    <div class="routing-servers-action-buttons">
      <div matTooltip="Add" [matTooltipPosition]="'right'">
        <button (click)="addInnerGroup()" mat-icon-button [disabled]="isUnauthorized || data.group.groups.length >= 5">
          <mat-icon [svgIcon]="isUnauthorized || data.group.groups.length >= 5 ? 'add_disabled' : 'add'" class="icon-display"></mat-icon>
        </button>
      </div>

      <div matTooltip="Edit" [matTooltipPosition]="'right'">
        <button (click)="editInnerGroup()"  mat-icon-button  [disabled]="!this.selectedInnerGroup || isUnauthorized">
          <mat-icon [svgIcon]="!this.selectedInnerGroup || isUnauthorized ? 'edit_disabled' : 'edit'" class="icon-display"></mat-icon>
        </button>
      </div>

      <div matTooltip="Delete"  [matTooltipPosition]="'right'">
        <button (click)="removeInnerGroup()"  mat-icon-button  [disabled]="!this.selectedInnerGroup || isUnauthorized">
          <mat-icon [svgIcon]="!this.selectedInnerGroup || isUnauthorized ? 'delete_disabled' : 'delete'" class="icon-display"></mat-icon>
        </button>
      </div>

      <div matTooltip="Move up" [matTooltipPosition]="'right'">
        <button (click)="moveUpInnerGroup()"  mat-icon-button
                [disabled]="!selectedInnerGroup ||  selectedInnerGroup.isFirst || isUnauthorized">
          <mat-icon  class="icons-inner">arrow_drop_up</mat-icon>
        </button>
      </div>

      <div matTooltip="Move down"  [matTooltipPosition]="'right'">
        <button (click)="moveDownInnerGroup()"  mat-icon-button
                [disabled]="!selectedInnerGroup || selectedInnerGroup.isLast || isUnauthorized">
          <mat-icon  class="icons-inner">arrow_drop_down</mat-icon>
        </button>
      </div>

    </div>
    <div class="inner-accordion-container">
      <table mat-table [dataSource]="data.group.groups">
        <ng-container matColumnDef="innerTitle">
          <td mat-cell *matCellDef="let element"> {{element.innerTitle}}</td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="path-row" [ngClass]="{'selected': selectedInnerGroup?.id === row.id}" (click)="selectHandler(row)">
        </tr>
      </table>
    </div>
  </div>

  <ac-line-separator [(collapsed)]="advancedCollapse" [isCollapsible]="true" title="Advanced">
    <div class="advanced">
      <mat-checkbox name="multipleSockets" color="primary" [(ngModel)]="data.group.multipleSockets" class="multipleSockets">
        Enable parallel connections (multiple sockets)
      </mat-checkbox>
    </div>
  </ac-line-separator>
</form>

